const HeaderIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="path-1-inside-1_2822_33862" fill="white">
      <rect x="5.33203" y="5.33398" width="9.48148" height="9.48148" rx="0.888889"/>
    </mask>
    <rect x="5.33203" y="5.33398" width="9.48148" height="9.48148" rx="0.888889" stroke="#899CBD" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" mask="url(#path-1-inside-1_2822_33862)"/>
    <mask id="path-2-inside-2_2822_33862" fill="white">
      <rect x="17.1836" y="5.33398" width="9.48148" height="9.48148" rx="0.888889"/>
    </mask>
    <rect x="17.1836" y="5.33398" width="9.48148" height="9.48148" rx="0.888889" stroke="#899CBD" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" mask="url(#path-2-inside-2_2822_33862)"/>
    <mask id="path-3-inside-3_2822_33862" fill="white">
      <rect x="17.1836" y="17.1855" width="9.48148" height="9.48148" rx="0.888889"/>
    </mask>
    <rect x="17.1836" y="17.1855" width="9.48148" height="9.48148" rx="0.888889" stroke="#899CBD" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" mask="url(#path-3-inside-3_2822_33862)"/>
    <mask id="path-4-inside-4_2822_33862" fill="white">
      <rect x="5.33203" y="17.1855" width="9.48148" height="9.48148" rx="0.888889"/>
    </mask>
    <rect x="5.33203" y="17.1855" width="9.48148" height="9.48148" rx="0.888889" stroke="#899CBD" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" mask="url(#path-4-inside-4_2822_33862)"/>
  </svg>
)

export default HeaderIcon